import React from 'react'
import { processDateInput } from '../DateInput'
import './keyboard.less'

export const HIDDEN_KEYBOARD_KEYS_LICENCE_PLATE = ['-', ' ']

interface KeyboardSymbol {
  label: string
  class?: string
}

const row0: KeyboardSymbol[] = [
  { label: '1' },
  { label: '2' },
  { label: '3' },
  { label: '4' },
  { label: '5' },
  { label: '6' },
  { label: '7' },
  { label: '8' },
  { label: '9' },
  { label: '0' },
  { label: '←', class: 'backspace' },
]
const row1: KeyboardSymbol[] = [
  { label: 'Q' },
  { label: 'W' },
  { label: 'E' },
  { label: 'R' },
  { label: 'T' },
  { label: 'Y' },
  { label: 'U' },
  { label: 'I' },
  { label: 'O' },
  { label: 'P' },
  { label: 'Ü' },
  { label: 'Õ' },
]
const row2: KeyboardSymbol[] = [
  { label: 'A' },
  { label: 'S' },
  { label: 'D' },
  { label: 'F' },
  { label: 'G' },
  { label: 'H' },
  { label: 'J' },
  { label: 'K' },
  { label: 'L' },
  { label: 'Ö' },
  { label: 'Ä' },
]
const row3: KeyboardSymbol[] = [
  { label: 'Å' },
  { label: 'Z' },
  { label: 'X' },
  { label: 'C' },
  { label: 'V' },
  { label: 'B' },
  { label: 'N' },
  { label: 'M' },
  { label: '-' },
  { label: ' ', class: 'space-bar' },
]

const keyRows = [row0, row1, row2, row3]

const EMPTY_DATE = '  .  .    '

interface Props {
  input?: HTMLInputElement
  onChange?: (value: string) => void
  format?: string
  onClose?: () => void
  hiddenKeys?: string[]
}

const insertToString = (start: number, end: number, val: string, key: string): string => {
  return val.substr(0, start) + key + val.substr(end, val.length)
}
const removeOneString = (start: number, end: number, val: string): string => {
  return start === 0
    ? val
    : start === end
    ? val.substr(0, start - 1) + val.substr(end, val.length - 1)
    : val.substr(0, start) + val.substr(end, val.length - 1)
}

const handleClick = (key: string, onChange?: (value: string) => void, input?: HTMLInputElement, format?: string) => {
  if (!input || !onChange) {
    return
  }

  const start = input.selectionStart || 0
  const end = input.selectionEnd || 0
  const val = input.value
  if (format === 'date') {
    const maxDateLength = 10
    processDateInput(input, key, start, val || EMPTY_DATE, maxDateLength)
  } else {
    if (key === '←') {
      var newValue = removeOneString(start, end, val)
      input.value = newValue
      const cursor = start === 0 ? 0 : start === end ? start - 1 : start
      input.focus()
      input.setSelectionRange(cursor, cursor)
    } else if (start === end && end === val.length) {
      input.value = val + key
      input.focus()
    } else {
      const newValue = insertToString(start, end, val, key)
      input.value = newValue
      const cursor = start + 1
      input.focus()
      input.setSelectionRange(cursor, cursor)
    }
  }
  onChange(input.value)
}

const Keyboard: React.FC<Props> = ({ input, onChange, onClose, format, hiddenKeys }: Props) => {
  const isNeedToHide = (key: KeyboardSymbol) => {
    return hiddenKeys && hiddenKeys.length && hiddenKeys.some((item) => item === key.label)
  }
  return (
    <div>
      <div className="keyboard">
        <div className="container">
          <button className="close-keyboard" onClick={onClose}>
            <b>{'╳'}</b>
          </button>
        </div>

        <div className="keyboard-rows">
          {keyRows.map((row, index) => (
            <div key={index} className="keyboard-row">
              {row.map((item) => {
                return (
                  <div
                    className={`key ${item.class || ''} ${isNeedToHide(item) ? 'hide' : ''}`}
                    key={item.label}
                    onClick={() => handleClick(item.label, onChange, input, format)}
                  >
                    <div>{item.label}</div>
                  </div>
                )
              })}
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
export default Keyboard
